import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.esm.min";

import { createPinia } from "pinia";
import { createApp } from "vue";

import "./root/modules/logs/enhance-console-functions.js";
import "./root/modules/logs/log-uncaught-errors.js";

import root from "./root/root.vue";
import { router } from "./root/router";

const app = createApp(root);

app.use(router);
app.use(createPinia());
app.mount("#root");
